import React from "react";
import { LayoutDashboard } from "lucide-react";
import { NavLink } from "react-router-dom";
import Images from "../Images";
import { logoutLink, navSections } from "../Links";

const itemClass = (isActive) =>
  `group flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
    isActive
      ? "bg-[#FF6C6C]/10 text-[#c94545]"
      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
  }`;

const iconClass = (isActive) =>
  `h-[18px] w-[18px] shrink-0 ${isActive ? "text-[#FF6C6C]" : "text-gray-400 group-hover:text-gray-600"}`;

const NavItem = ({ to, end, icon: Icon, children }) => (
  <NavLink to={to} end={end} className={({ isActive }) => itemClass(isActive)}>
    {({ isActive }) => (
      <>
        <Icon className={iconClass(isActive)} aria-hidden="true" />
        <span className="truncate">{children}</span>
      </>
    )}
  </NavLink>
);

const Sidebar = () => (
  <div className="fixed flex h-screen w-64 flex-col border-r border-gray-200 bg-white">
    <div className="flex w-full items-center justify-center px-4 py-4">
      <img src={Images.logo} alt="Dealboxx" className="h-9 w-auto max-w-[11rem] object-contain" />
    </div>
    <nav className="flex-1 overflow-y-auto px-3 pb-4" aria-label="Admin">
      <ul className="space-y-0.5">
        <li>
          <NavItem to="/dashboard" icon={LayoutDashboard}>
            Dashboard
          </NavItem>
        </li>
      </ul>
      {navSections.map((section) => (
        <div key={section.id} className="mt-5">
          <p className="px-3 pb-1.5 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
            {section.title}
          </p>
          <ul className="space-y-0.5">
            {section.links.map((link) => (
              <li key={link.link}>
                <NavItem to={link.link} end={link.link === "/deals"} icon={link.icon}>
                  {link.name}
                </NavItem>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
    <div className="border-t border-gray-100 p-3">
      <NavItem to={logoutLink.link} icon={logoutLink.icon}>
        {logoutLink.name}
      </NavItem>
    </div>
  </div>
);

export default Sidebar;
